import { render, staticRenderFns } from "./GeraCreditos.vue?vue&type=template&id=3c3d9b9a"
import script from "./GeraCreditos.vue?vue&type=script&lang=js"
export * from "./GeraCreditos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports